import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default {
  components: {
    AzIcon: AzIcon
  },
  setup: function setup() {
    var _useCustomizer = useCustomizer(),
      customizer = _useCustomizer.customizer,
      goToPreviousStep = _useCustomizer.goToPreviousStep,
      openClosingOverlay = _useCustomizer.openClosingOverlay,
      hasPreviousStep = _useCustomizer.hasPreviousStep,
      closeProductOverlay = _useCustomizer.closeProductOverlay,
      closeCustomizer = _useCustomizer.closeCustomizer;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var title = computed(function () {
      if (customizer.value.productOverlay) return translate('customizer.seeMore');
      if (customizer.value.isClosingOverlay) return translate('customizer.closingOverlay.title');
      return translate('customizer.headerTitle');
    });
    var onBackClick = function onBackClick() {
      if (customizer.value.productOverlay) closeProductOverlay();else goToPreviousStep();
    };
    var closePage = function closePage() {
      if (customizer.value.step === 1) return closeCustomizer();
      openClosingOverlay();
    };
    return {
      customizer: customizer,
      hasPreviousStep: hasPreviousStep,
      translate: translate,
      title: title,
      onBackClick: onBackClick,
      closePage: closePage
    };
  }
};